<template>
  <DsShowcase title="DividerPlay" description="Separador visual horizontal ou vertical.">
    <!-- PROP: horizontal (default) -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Horizontal (padrão)</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Renderiza como linha horizontal de 1px</p>
      <div class="tw:p-4 tw:border tw:rounded-lg">
        <p class="tw:text-sm">Conteúdo acima</p>
        <DividerPlay class="tw:my-4" />
        <p class="tw:text-sm">Conteúdo abaixo</p>
      </div>
    </section>

    <!-- PROP: vertical -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">vertical</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — renderiza como linha vertical</p>
      <div class="tw:p-4 tw:border tw:rounded-lg tw:flex tw:items-center tw:gap-4 tw:h-16">
        <span class="tw:text-sm">Item A</span>
        <DividerPlay :vertical="true" />
        <span class="tw:text-sm">Item B</span>
        <DividerPlay :vertical="true" />
        <span class="tw:text-sm">Item C</span>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { DividerPlay } from '@/components/atomic'
</script>
